export default __webpack_public_path__ + "static/media/entropyfi_banner.c54b5016.png";